import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function ExamAttemptsPage() {
  return <InstituteCrudPage config={entityConfigs['exam-attempts']} />;
}
